<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_import_file') || '产线报工记录导入'"
      visible
      direction="rtl"
      :size="1200"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main ref="main" @close="close()" @reload="$emit('reload')" />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  data() {
    return { visible: false }
  },
  methods: {
    close() {
      this.visible = false
    },
    open({ file } = {}) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.main.load({ file })
      })
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
